
import { Brain, TrendingUp } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";

const EmptyState = () => {
  return (
    <Card className="bg-secondary/50 backdrop-blur-lg border-2 border-primary">
      <CardContent className="p-8 text-center">
        <div className="flex flex-col items-center space-y-4">
          <div className="relative">
            <Brain className="h-16 w-16 text-primary" />
            <TrendingUp className="h-6 w-6 text-green-400 absolute -bottom-1 -right-1" />
          </div>
          <div className="space-y-2">
            <h3 className="text-xl font-semibold text-white">AI Performance Insights</h3>
            <p className="text-gray-300 max-w-md">
              Generate intelligent insights from your performance management data across multiple years. 
              Analyze talent trajectories, skill gaps, succession planning, and more.
            </p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default EmptyState;
